import '../scss/style.scss';

import './loading';
import './polyfill';
import './firstViewBg';
import './particleBg';
import './inView';
import './smoothScroll';
import './parallax';
import './modal';
import './swiper';
import './contact';

import { drawerConfig } from './drawer';

drawerConfig();

window.addEventListener('load', () => {
  const copyrightYear = document.querySelector('.js-copyrightYear');
  const currentYear = new Date().getFullYear();
  copyrightYear.textContent = currentYear;
});
